import { ArrowDown, ArrowUp, Minus } from 'lucide-react';

import type { KPIItem } from '../../types/report';
import { cn } from '../../lib/utils';

interface KPICardProps {
  item: KPIItem;
  trend?: 'up' | 'down' | 'neutral';
  className?: string;
}

const formatValue = (value: number, unit: string): string => {
  if (unit === '원') {
    if (value >= 100000000) {
      return `${(value / 100000000).toFixed(2)}억`;
    }
    if (value >= 10000) {
      return `${(value / 10000).toFixed(0)}만`;
    }
    return value.toLocaleString();
  }
  if (unit === '%') {
    return `${value.toFixed(2)}%`;
  }
  if (unit === '건') {
    return value.toLocaleString();
  }
  return value.toString();
};

export const KPICard = ({ item, trend = 'neutral', className }: KPICardProps) => {
  const TrendIcon = trend === 'up' ? ArrowUp : trend === 'down' ? ArrowDown : Minus;
  const trendColor = trend === 'up' ? 'text-green-500' : trend === 'down' ? 'text-red-500' : 'text-gray-400';

  return (
    <div className={cn('rounded-lg border bg-white p-4 shadow-sm', className)}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-500">{item.label}</p>
          <p className="mt-1 text-2xl font-bold text-gray-900">{formatValue(item.value, item.unit)}</p>
        </div>
        <div className={cn('rounded-full p-1', trendColor)}>
          <TrendIcon className="h-4 w-4" />
        </div>
      </div>
      <p className="mt-2 text-xs text-gray-500 line-clamp-2">{item.evaluation}</p>
    </div>
  );
};
